import { tns } from 'tiny-slider';

export function actueelSlider() {
    let slider = document.getElementById('actueel-slider');
    if (slider) {
        slider = tns({
            container: '#actueel-slider',
            items: 1.125,
            gutter: 16,
            autoplay: false,
            nav: true,
            navPosition: 'bottom',
            mouseDrag: true,
            touch: true,
            controls: true,
            controlsPosition: 'bottom',
            controlsText: ['<span class="icon-basic icon-chevron-left-circled"></span>', '<span class="icon-basic icon-chevron-right-circled"></span>'],
            responsive: {
                576: {
                    items: 1.5
                },
                768: {
                    items: 2,
                    gutter: 32
                },
                1024: {
                    items: 3,
                    gutter: 16
                },
                1320: {
                    gutter: 80
                }
            }
        });
    }

    return 'actueelSlider';

}
